// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DAppIncompatibilityWarningMsg_wrapper__2t_Jt","title":"DAppIncompatibilityWarningMsg_title__SwbdH","message":"DAppIncompatibilityWarningMsg_message__UbbQ0"};